import type { IIndirectTaxAvailableRegistrationV2 } from '@commenda/api/indirect-tax/registrations/types';
import { LoadingIndicator, SingleCombobox } from '@commenda/kakashi';

interface IndirectTaxRegistrationFieldProps {
  availableRegistrations: IIndirectTaxAvailableRegistrationV2[];
  isLoading: boolean;
  isError?: boolean;
  selectedRegistrationId: string;
  onRegistrationChange: (registrationId: string) => void;
  isLocked?: boolean;
  registrationName?: string;
}

export function IndirectTaxRegistrationField({
  availableRegistrations,
  isLoading,
  isError = false,
  selectedRegistrationId,
  onRegistrationChange,
  isLocked = false,
  registrationName,
}: IndirectTaxRegistrationFieldProps) {
  const registrationOptions = availableRegistrations.map((r) => ({
    value: r.registrationId,
    label: r.registrationName,
  }));

  return (
    <div className="flex flex-col gap-xs">
      <p className="txt-small-medium text-text-secondary">
        Registration
        {!isLocked && (
          <span className="text-utility-violet-600 ml-0.5">*</span>
        )}
      </p>
      {isLocked ? (
        <div className="flex items-center h-11 px-3 rounded-lg border border-border-primary bg-bg-secondary txt-medium-regular text-text-secondary">
          {registrationName ||
            registrationOptions.find((o) => o.value === selectedRegistrationId)
              ?.label ||
            selectedRegistrationId}
        </div>
      ) : isLoading ? (
        <div className="flex items-center gap-sm h-11">
          <LoadingIndicator size={16} />
          <span className="txt-small-regular text-text-tertiary">
            Loading available registrations...
          </span>
        </div>
      ) : isError ? (
        <p className="txt-small-regular text-text-error">
          Failed to load registrations.
        </p>
      ) : availableRegistrations.length === 0 ? (
        <p className="txt-small-regular text-text-tertiary">
          No registrations available for this region.
        </p>
      ) : (
        <SingleCombobox
          value={selectedRegistrationId}
          setValue={onRegistrationChange}
          options={registrationOptions}
          placeholder="Select registration"
          _className="txt-medium-regular text-text-secondary h-11 px-3"
          canClearSelection={false}
        />
      )}
    </div>
  );
}
